export const toc = () => {
    document.querySelectorAll('.js-toc-collapse').forEach((toc) => {
        const button = toc.querySelector('.js-toc-toggle')
        const list = toc.querySelector('.js-toc-list')

        console.log(button, list);

        if (!button || !list) {
            return
        }

        button.addEventListener('click', () => {
            const isOpen = toc.classList.toggle('is-open')

            button.setAttribute('aria-expanded', String(isOpen))
            list.hidden = !isOpen
        })
    })
}
